<template>
  <b-row>
    <b-col cols="12">
      <b-card header="Listado de personal">
        <div class="table-responsive">
          <div class="form-group form-inline pull-left">
            <input
              v-model="search"
              type="search"
              class="form-control"
              placeholder="Buscar..."
            />
            &nbsp;
          </div>
          <div class="form-group form-inline pull-right">
            <download-excel
              class="btn btn-primary"
              :fields="json_fields"
              :data="filterUsers"
              name="usuarios.xls"
            >
              Exportar </download-excel
            >&nbsp;
            <button @click="newUser" type="button" class="btn btn-primary">
              Nuevo
            </button>
          </div>

          <table class="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Email</th>
                <th>Celular</th>
                <th>Perfil</th>
                <th>Modo</th>
                <th>Activo</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(user, k) in filterUsers"
                :key="k"
                @contextmenu.prevent="selectUser(user)"
              >
                <td>{{ user.name }} {{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.mobile }}</td>
                <td>{{ user.role.name }}</td>
                <td>{{ user.driver_mode ? user.driver_mode.name : "--" }}</td>
                <td>
                  <span
                    :class="
                      `badge ${user.active ? 'badge-success' : 'badge-warning'}`
                    "
                    >{{ user.active ? "ACTIVO" : "INACTIVO" }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <context-menu ref="ctxMenu">
            <li class="ctx-item" @click="editUser()">Editar</li>
          </context-menu>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/helpers/api";

export default {
  data() {
    return {
      search: "",
      users: [],
      user: {},
      json_fields: {
        Nombre: {
          callback: user => {
            return user.name + " " + user.last_name ? user.last_name : "";
          }
        },
        Email: "email",
        Celular: "mobile",
        Perfil: {
          field: "role",
          callback: role => {
            return role ? role.name : "";
          }
        },
        Modo: {
          field: "driver_mode",
          callback: driver_mode => {
            return driver_mode ? driver_mode.name : "--";
          }
        },
        Activo: {
          field: "active",
          callback: active => {
            return active ? "Activo" : "Inactivo";
          }
        }
      }
    };
  },
  computed: {
    filterUsers() {
      return this.users.filter(user => {
        let condition = true;
        if (this.search) {
          let txt = this.search.toLowerCase();
          condition =
            condition &&
            (`${user.name} ${user.last_name}`.toLowerCase().includes(txt) ||
              user.email.toLowerCase().includes(txt) ||
              user.role.name.toLowerCase().includes(txt));
        }

        return condition;
      });
    }
  },
  mounted() {
    api.get("/users").then(response => {
      this.users = response.users;
    });
  },
  methods: {
    selectUser(user) {
      this.user = user;
      this.$refs.ctxMenu.open();
    },
    editUser() {
      this.$router.push(`/rrhh/users/edit/${this.user.id}`);
    },
    newUser() {
      this.$router.push("/rrhh/users/new");
    }
  }
};
</script>
